require('../polly/presigner');



//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/lib/services/polly.js
// module id = 893
// module chunks = 1